import { ReactNode } from 'react';
import { Skeleton, Text, TextProps } from '@electricjs/arc';

import InlineError from './InlineError';

export type InlineLazyTextProps = {
  loading?: boolean;
  error?: boolean;
  children: ReactNode;
  textProps?: Omit<TextProps, 'children'>;
};

/** Renders a Text component, handling inline loading and error states */
export const InlineLazyText = ({
  loading,
  error,
  children,
  textProps,
}: InlineLazyTextProps) => {
  if (loading) {
    return <Skeleton width="6rem" />;
  } else if (error) {
    return <InlineError />;
  } else {
    return <Text {...textProps}>{children}</Text>;
  }
};
